module.exports = __webpack_public_path__ + "img/set_wallpaper_3.55b1f46d.png";